export const mapStyles = [
  {
    name: 'streets-v10',
    link: 'mapbox://styles/mapbox/streets-v10',
  },
  {
    name: 'outdoors-v10',
    link: 'mapbox://styles/mapbox/outdoors-v10',
  },
  {
    name: 'light-v9',
    link: 'mapbox://styles/mapbox/light-v9',
  },
  {
    name: 'dark-v9',
    link: 'mapbox://styles/mapbox/dark-v9',
  },
  {
    name: 'satellite-v9',
    link: 'mapbox://styles/mapbox/satellite-v9',
  },
  {
    name: 'satellite-streets-v10',
    link: 'mapbox://styles/mapbox/satellite-streets-v10',
  },
  {
    name: 'navigation-preview-day-v2',
    link: 'mapbox://styles/mapbox/navigation-preview-day-v2',
  },
  {
    name: 'navigation-preview-night-v2',
    link: 'mapbox://styles/mapbox/navigation-preview-night-v2',
  },
  {
    name: 'navigation-guidance-day-v2',
    link: 'mapbox://styles/mapbox/navigation-guidance-day-v2',
  },
  {
    name: 'navigation-guidance-night-v2',
    link: 'mapbox://styles/mapbox/navigation-guidance-night-v2',
  },
];
